

import React, { memo, useContext } from 'react';
import { TREE_DEEP_LEVEL } from '@shootsta/tree';

import { getDataTableColumnsCount } from '../../utils/factories/dataTableColumnFactory';
import DataTableBodyCell from './DataTableBodyCell';
import DataTableBodyRow from './DataTableBodyRow';

import { DataTableContext } from '../../context/dataTableContext';






const ROW = {};
const ROW_INDEX = 0;
const TREE_ROW_NODE = {
  data: ROW,
  isExpanded: false,
  deepLevel: TREE_DEEP_LEVEL.ROOT,
  children: null
};

const DataTableBodyFullWidthRow = (props) => {
  const { column, isExpander } = props;

  const { columns } = useContext(DataTableContext);

  const columnsCount = getDataTableColumnsCount(columns);

  return (
    <DataTableBodyRow
      rowIndex={ROW_INDEX}
      treeRowNode={TREE_ROW_NODE}
      isExpander={isExpander}>

      <DataTableBodyCell
        treeRowNode={TREE_ROW_NODE}
        column={column}
        colSpan={columnsCount} />

    </DataTableBodyRow>);

};

export default memo(DataTableBodyFullWidthRow);